import styled from 'styled-components';

const CustomLine = styled.div<{
  width?: string;
  height?: string;
  color?: string;
  vertical?: boolean;
  margin?: string;
}>`
  width: ${p => p.width || (p.vertical ? '1px' : '100%')};
  height: ${p => p.height || (p.vertical ? '100%' : '1px')};
  background-color: ${p => p.color || '#f1f1f1'};
  margin: ${p => p.margin || '0 18px'};
  flex-shrink: 0;
`;
const Line = ({
  width,
  height,
  color,
  vertical = true,
  margin,
  zIndex,
}: VerticalLineProps): JSX.Element => (
  <>
    {zIndex != undefined ? (
      <CustomLine
        color={color}
        height={height}
        margin={margin}
        style={{ zIndex }}
        vertical={vertical}
        width={width}
      />
    ) : (
      <CustomLine
        color={color}
        height={height}
        margin={margin}
        vertical={vertical}
        width={width}
      />
    )}
  </>
);

export default Line;

export interface VerticalLineProps {
  width?: string;
  height?: string;
  color?: string;
  vertical?: boolean;
  margin?: string;
  zIndex?: number;
}
